"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _FedexShipmentOptionsAllOf = _interopRequireDefault(require("./FedexShipmentOptionsAllOf"));

var _GenesisShipmentOptions = _interopRequireDefault(require("./GenesisShipmentOptions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The FedexShipmentOptions model module.
 * @module model/FedexShipmentOptions
 * @version 2.7.64
 */
var FedexShipmentOptions = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>FedexShipmentOptions</code>.
   * Shipment rating and dispatch options specific to FedEx
   * @alias module:model/FedexShipmentOptions
   * @implements module:model/GenesisShipmentOptions
   * @implements module:model/FedexShipmentOptionsAllOf
   */
  function FedexShipmentOptions() {
    _classCallCheck(this, FedexShipmentOptions);

    _GenesisShipmentOptions["default"].initialize(this);

    _FedexShipmentOptionsAllOf["default"].initialize(this);

    FedexShipmentOptions.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(FedexShipmentOptions, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>FedexShipmentOptions</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FedexShipmentOptions} obj Optional instance to populate.
     * @return {module:model/FedexShipmentOptions} The populated <code>FedexShipmentOptions</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new FedexShipmentOptions();

        _GenesisShipmentOptions["default"].constructFromObject(data, obj);

        _FedexShipmentOptionsAllOf["default"].constructFromObject(data, obj);

        if (data.hasOwnProperty('bill_to_account_number')) {
          obj['bill_to_account_number'] = _ApiClient["default"].convertToType(data['bill_to_account_number'], 'String');
        }

        if (data.hasOwnProperty('bill_to_country_code')) {
          obj['bill_to_country_code'] = _ApiClient["default"].convertToType(data['bill_to_country_code'], 'String');
        }

        if (data.hasOwnProperty('bill_to_payment_type')) {
          obj['bill_to_payment_type'] = _ApiClient["default"].convertToType(data['bill_to_payment_type'], 'String');
        }

        if (data.hasOwnProperty('bill_to_postal_code')) {
          obj['bill_to_postal_code'] = _ApiClient["default"].convertToType(data['bill_to_postal_code'], 'String');
        }

        if (data.hasOwnProperty('cod_collection_amount')) {
          obj['cod_collection_amount'] = _ApiClient["default"].convertToType(data['cod_collection_amount'], 'Number');
        }

        if (data.hasOwnProperty('cod_collection_currency')) {
          obj['cod_collection_currency'] = _ApiClient["default"].convertToType(data['cod_collection_currency'], 'String');
        }

        if (data.hasOwnProperty('cod_collection_type')) {
          obj['cod_collection_type'] = _ApiClient["default"].convertToType(data['cod_collection_type'], 'String');
        }

        if (data.hasOwnProperty('customer_transaction_id')) {
          obj['customer_transaction_id'] = _ApiClient["default"].convertToType(data['customer_transaction_id'], 'String');
        }

        if (data.hasOwnProperty('signature_option_release_number')) {
          obj['signature_option_release_number'] = _ApiClient["default"].convertToType(data['signature_option_release_number'], 'String');
        }

        if (data.hasOwnProperty('signature_option_signature_type')) {
          obj['signature_option_signature_type'] = _ApiClient["default"].convertToType(data['signature_option_signature_type'], 'String');
        }

        if (data.hasOwnProperty('account')) {
          obj['account'] = _ApiClient["default"].convertToType(data['account'], 'String');
        }

        if (data.hasOwnProperty('alcohol_recipient_type')) {
          obj['alcohol_recipient_type'] = _ApiClient["default"].convertToType(data['alcohol_recipient_type'], 'String');
        }

        if (data.hasOwnProperty('battery_material_type')) {
          obj['battery_material_type'] = _ApiClient["default"].convertToType(data['battery_material_type'], 'String');
        }

        if (data.hasOwnProperty('battery_packaging_type')) {
          obj['battery_packaging_type'] = _ApiClient["default"].convertToType(data['battery_packaging_type'], 'String');
        }

        if (data.hasOwnProperty('dropoff_type')) {
          obj['dropoff_type'] = _ApiClient["default"].convertToType(data['dropoff_type'], 'String');
        }

        if (data.hasOwnProperty('home_delivery_date')) {
          obj['home_delivery_date'] = _ApiClient["default"].convertToType(data['home_delivery_date'], 'String');
        }

        if (data.hasOwnProperty('home_delivery_phone_number')) {
          obj['home_delivery_phone_number'] = _ApiClient["default"].convertToType(data['home_delivery_phone_number'], 'String');
        }

        if (data.hasOwnProperty('home_delivery_type')) {
          obj['home_delivery_type'] = _ApiClient["default"].convertToType(data['home_delivery_type'], 'String');
        }

        if (data.hasOwnProperty('packaging')) {
          obj['packaging'] = _ApiClient["default"].convertToType(data['packaging'], 'String');
        }

        if (data.hasOwnProperty('service_code')) {
          obj['service_code'] = _ApiClient["default"].convertToType(data['service_code'], 'String');
        }

        if (data.hasOwnProperty('shipment_services')) {
          obj['shipment_services'] = _ApiClient["default"].convertToType(data['shipment_services'], ['String']);
        }

        if (data.hasOwnProperty('smart_post_indicia_type')) {
          obj['smart_post_indicia_type'] = _ApiClient["default"].convertToType(data['smart_post_indicia_type'], 'String');
        }

        if (data.hasOwnProperty('use_preferred_rates')) {
          obj['use_preferred_rates'] = _ApiClient["default"].convertToType(data['use_preferred_rates'], 'Boolean');
        }
      }

      return obj;
    }
  }]);

  return FedexShipmentOptions;
}();
/**
 * @member {String} bill_to_account_number
 */


FedexShipmentOptions.prototype['bill_to_account_number'] = undefined;
/**
 * @member {String} bill_to_country_code
 */

FedexShipmentOptions.prototype['bill_to_country_code'] = undefined;
/**
 * @member {module:model/FedexShipmentOptions.BillToPaymentTypeEnum} bill_to_payment_type
 */

FedexShipmentOptions.prototype['bill_to_payment_type'] = undefined;
/**
 * @member {String} bill_to_postal_code
 */

FedexShipmentOptions.prototype['bill_to_postal_code'] = undefined;
/**
 * @member {Number} cod_collection_amount
 */

FedexShipmentOptions.prototype['cod_collection_amount'] = undefined;
/**
 * @member {module:model/FedexShipmentOptions.CodCollectionCurrencyEnum} cod_collection_currency
 * @default 'USD'
 */

FedexShipmentOptions.prototype['cod_collection_currency'] = 'USD';
/**
 * @member {module:model/FedexShipmentOptions.CodCollectionTypeEnum} cod_collection_type
 */

FedexShipmentOptions.prototype['cod_collection_type'] = undefined;
/**
 * @member {String} customer_transaction_id
 */

FedexShipmentOptions.prototype['customer_transaction_id'] = undefined;
/**
 * @member {String} signature_option_release_number
 */

FedexShipmentOptions.prototype['signature_option_release_number'] = undefined;
/**
 * @member {module:model/FedexShipmentOptions.SignatureOptionSignatureTypeEnum} signature_option_signature_type
 */

FedexShipmentOptions.prototype['signature_option_signature_type'] = undefined;
/**
 * Id of the FedexAccount to dispatch or rate with, if using FedEx direct rating or dispatch
 * @member {String} account
 */

FedexShipmentOptions.prototype['account'] = undefined;
/**
 * @member {module:model/FedexShipmentOptions.AlcoholRecipientTypeEnum} alcohol_recipient_type
 */

FedexShipmentOptions.prototype['alcohol_recipient_type'] = undefined;
/**
 * @member {module:model/FedexShipmentOptions.BatteryMaterialTypeEnum} battery_material_type
 */

FedexShipmentOptions.prototype['battery_material_type'] = undefined;
/**
 * @member {module:model/FedexShipmentOptions.BatteryPackagingTypeEnum} battery_packaging_type
 */

FedexShipmentOptions.prototype['battery_packaging_type'] = undefined;
/**
 * @member {module:model/FedexShipmentOptions.DropoffTypeEnum} dropoff_type
 */

FedexShipmentOptions.prototype['dropoff_type'] = undefined;
/**
 * @member {String} home_delivery_date
 */

FedexShipmentOptions.prototype['home_delivery_date'] = undefined;
/**
 * @member {String} home_delivery_phone_number
 */

FedexShipmentOptions.prototype['home_delivery_phone_number'] = undefined;
/**
 * @member {module:model/FedexShipmentOptions.HomeDeliveryTypeEnum} home_delivery_type
 */

FedexShipmentOptions.prototype['home_delivery_type'] = undefined;
/**
 * @member {String} packaging
 */

FedexShipmentOptions.prototype['packaging'] = undefined;
/**
 * @member {module:model/FedexShipmentOptions.ServiceCodeEnum} service_code
 */

FedexShipmentOptions.prototype['service_code'] = undefined;
/**
 * @member {Array.<String>} shipment_services
 */

FedexShipmentOptions.prototype['shipment_services'] = undefined;
/**
 * @member {module:model/FedexShipmentOptions.SmartPostIndiciaTypeEnum} smart_post_indicia_type
 */

FedexShipmentOptions.prototype['smart_post_indicia_type'] = undefined;
/**
 * @member {Boolean} use_preferred_rates
 * @default false
 */

FedexShipmentOptions.prototype['use_preferred_rates'] = false; // Implement GenesisShipmentOptions interface:

/**
 * @member {String} bill_to_account_number
 */

_GenesisShipmentOptions["default"].prototype['bill_to_account_number'] = undefined;
/**
 * @member {String} bill_to_country_code
 */

_GenesisShipmentOptions["default"].prototype['bill_to_country_code'] = undefined;
/**
 * @member {module:model/GenesisShipmentOptions.BillToPaymentTypeEnum} bill_to_payment_type
 */

_GenesisShipmentOptions["default"].prototype['bill_to_payment_type'] = undefined;
/**
 * @member {String} bill_to_postal_code
 */

_GenesisShipmentOptions["default"].prototype['bill_to_postal_code'] = undefined;
/**
 * @member {Number} cod_collection_amount
 */

_GenesisShipmentOptions["default"].prototype['cod_collection_amount'] = undefined;
/**
 * @member {module:model/GenesisShipmentOptions.CodCollectionCurrencyEnum} cod_collection_currency
 * @default 'USD'
 */

_GenesisShipmentOptions["default"].prototype['cod_collection_currency'] = 'USD';
/**
 * @member {module:model/GenesisShipmentOptions.CodCollectionTypeEnum} cod_collection_type
 */

_GenesisShipmentOptions["default"].prototype['cod_collection_type'] = undefined;
/**
 * @member {String} customer_transaction_id
 */

_GenesisShipmentOptions["default"].prototype['customer_transaction_id'] = undefined;
/**
 * @member {String} signature_option_release_number
 */

_GenesisShipmentOptions["default"].prototype['signature_option_release_number'] = undefined;
/**
 * @member {module:model/GenesisShipmentOptions.SignatureOptionSignatureTypeEnum} signature_option_signature_type
 */

_GenesisShipmentOptions["default"].prototype['signature_option_signature_type'] = undefined; // Implement FedexShipmentOptionsAllOf interface:

/**
 * Id of the FedexAccount to dispatch or rate with, if using FedEx direct rating or dispatch
 * @member {String} account
 */

_FedexShipmentOptionsAllOf["default"].prototype['account'] = undefined;
/**
 * @member {module:model/FedexShipmentOptionsAllOf.AlcoholRecipientTypeEnum} alcohol_recipient_type
 */

_FedexShipmentOptionsAllOf["default"].prototype['alcohol_recipient_type'] = undefined;
/**
 * @member {module:model/FedexShipmentOptionsAllOf.BatteryMaterialTypeEnum} battery_material_type
 */

_FedexShipmentOptionsAllOf["default"].prototype['battery_material_type'] = undefined;
/**
 * @member {module:model/FedexShipmentOptionsAllOf.BatteryPackagingTypeEnum} battery_packaging_type
 */

_FedexShipmentOptionsAllOf["default"].prototype['battery_packaging_type'] = undefined;
/**
 * @member {module:model/FedexShipmentOptionsAllOf.DropoffTypeEnum} dropoff_type
 */

_FedexShipmentOptionsAllOf["default"].prototype['dropoff_type'] = undefined;
/**
 * @member {String} home_delivery_date
 */

_FedexShipmentOptionsAllOf["default"].prototype['home_delivery_date'] = undefined;
/**
 * @member {String} home_delivery_phone_number
 */

_FedexShipmentOptionsAllOf["default"].prototype['home_delivery_phone_number'] = undefined;
/**
 * @member {module:model/FedexShipmentOptionsAllOf.HomeDeliveryTypeEnum} home_delivery_type
 */

_FedexShipmentOptionsAllOf["default"].prototype['home_delivery_type'] = undefined;
/**
 * @member {String} packaging
 */

_FedexShipmentOptionsAllOf["default"].prototype['packaging'] = undefined;
/**
 * @member {module:model/FedexShipmentOptionsAllOf.ServiceCodeEnum} service_code
 */

_FedexShipmentOptionsAllOf["default"].prototype['service_code'] = undefined;
/**
 * @member {Array.<String>} shipment_services
 */

_FedexShipmentOptionsAllOf["default"].prototype['shipment_services'] = undefined;
/**
 * @member {module:model/FedexShipmentOptionsAllOf.SmartPostIndiciaTypeEnum} smart_post_indicia_type
 */

_FedexShipmentOptionsAllOf["default"].prototype['smart_post_indicia_type'] = undefined;
/**
 * @member {Boolean} use_preferred_rates
 * @default false
 */

_FedexShipmentOptionsAllOf["default"].prototype['use_preferred_rates'] = false;
/**
 * Allowed values for the <code>bill_to_payment_type</code> property.
 * @enum {String}
 * @readonly
 */

FedexShipmentOptions['BillToPaymentTypeEnum'] = {
  /**
   * value: "COLLECT"
   * @const
   */
  "COLLECT": "COLLECT",

  /**
   * value: "RECIPIENT"
   * @const
   */
  "RECIPIENT": "RECIPIENT",

  /**
   * value: "SENDER"
   * @const
   */
  "SENDER": "SENDER",

  /**
   * value: "THIRD_PARTY"
   * @const
   */
  "THIRD_PARTY": "THIRD_PARTY"
};
/**
 * Allowed values for the <code>cod_collection_currency</code> property.
 * @enum {String}
 * @readonly
 */

FedexShipmentOptions['CodCollectionCurrencyEnum'] = {
  /**
   * value: "CAD"
   * @const
   */
  "CAD": "CAD",

  /**
   * value: "USD"
   * @const
   */
  "USD": "USD"
};
/**
 * Allowed values for the <code>cod_collection_type</code> property.
 * @enum {String}
 * @readonly
 */

FedexShipmentOptions['CodCollectionTypeEnum'] = {
  /**
   * value: "ANY"
   * @const
   */
  "ANY": "ANY",

  /**
   * value: "COMPANY_CHECK"
   * @const
   */
  "COMPANY_CHECK": "COMPANY_CHECK",

  /**
   * value: "GUARANTEED_FUNDS"
   * @const
   */
  "GUARANTEED_FUNDS": "GUARANTEED_FUNDS",

  /**
   * value: "PERSONAL_CHECK"
   * @const
   */
  "PERSONAL_CHECK": "PERSONAL_CHECK"
};
/**
 * Allowed values for the <code>signature_option_signature_type</code> property.
 * @enum {String}
 * @readonly
 */

FedexShipmentOptions['SignatureOptionSignatureTypeEnum'] = {
  /**
   * value: "ADULT_SIGNATURE"
   * @const
   */
  "ADULT_SIGNATURE": "ADULT_SIGNATURE",

  /**
   * value: "DIRECT_SIGNATURE"
   * @const
   */
  "DIRECT_SIGNATURE": "DIRECT_SIGNATURE",

  /**
   * value: "NO_SIGNATURE"
   * @const
   */
  "NO_SIGNATURE": "NO_SIGNATURE",

  /**
   * value: "INDIRECT_SIGNATURE"
   * @const
   */
  "INDIRECT_SIGNATURE": "INDIRECT_SIGNATURE",

  /**
   * value: "SERVICE_DEFAULT"
   * @const
   */
  "SERVICE_DEFAULT": "SERVICE_DEFAULT"
};
/**
 * Allowed values for the <code>alcohol_recipient_type</code> property.
 * @enum {String}
 * @readonly
 */

FedexShipmentOptions['AlcoholRecipientTypeEnum'] = {
  /**
   * value: "CONSUMER"
   * @const
   */
  "CONSUMER": "CONSUMER",

  /**
   * value: "LICENSEE"
   * @const
   */
  "LICENSEE": "LICENSEE"
};
/**
 * Allowed values for the <code>battery_material_type</code> property.
 * @enum {String}
 * @readonly
 */

FedexShipmentOptions['BatteryMaterialTypeEnum'] = {
  /**
   * value: "LITHIUM_ION"
   * @const
   */
  "ION": "LITHIUM_ION",

  /**
   * value: "LITHIUM_METAL"
   * @const
   */
  "METAL": "LITHIUM_METAL"
};
/**
 * Allowed values for the <code>battery_packaging_type</code> property.
 * @enum {String}
 * @readonly
 */

FedexShipmentOptions['BatteryPackagingTypeEnum'] = {
  /**
   * value: "CONTAINED_IN_EQUIPMENT"
   * @const
   */
  "CONTAINED_IN_EQUIPMENT": "CONTAINED_IN_EQUIPMENT",

  /**
   * value: "PACKED_WITH_EQUIPMENT"
   * @const
   */
  "PACKED_WITH_EQUIPMENT": "PACKED_WITH_EQUIPMENT"
};
/**
 * Allowed values for the <code>dropoff_type</code> property.
 * @enum {String}
 * @readonly
 */

FedexShipmentOptions['DropoffTypeEnum'] = {
  /**
   * value: "REGULAR_PICKUP"
   * @const
   */
  "REGULAR_PICKUP": "REGULAR_PICKUP",

  /**
   * value: "STATION"
   * @const
   */
  "STATION": "STATION",

  /**
   * value: "REQUEST_COURIER"
   * @const
   */
  "REQUEST_COURIER": "REQUEST_COURIER",

  /**
   * value: "BUSINESS_SERVICE_CENTER"
   * @const
   */
  "BUSINESS_SERVICE_CENTER": "BUSINESS_SERVICE_CENTER",

  /**
   * value: "DROP_BOX"
   * @const
   */
  "DROP_BOX": "DROP_BOX"
};
/**
 * Allowed values for the <code>home_delivery_type</code> property.
 * @enum {String}
 * @readonly
 */

FedexShipmentOptions['HomeDeliveryTypeEnum'] = {
  /**
   * value: "APPOINTMENT"
   * @const
   */
  "APPOINTMENT": "APPOINTMENT",

  /**
   * value: "DATE_CERTAIN"
   * @const
   */
  "DATE_CERTAIN": "DATE_CERTAIN",

  /**
   * value: "EVENING"
   * @const
   */
  "EVENING": "EVENING"
};
/**
 * Allowed values for the <code>service_code</code> property.
 * @enum {String}
 * @readonly
 */

FedexShipmentOptions['ServiceCodeEnum'] = {
  /**
   * value: "FEDEX_1_DAY_FREIGHT"
   * @const
   */
  "FEDEX_1_DAY_FREIGHT": "FEDEX_1_DAY_FREIGHT",

  /**
   * value: "FEDEX_2_DAY"
   * @const
   */
  "FEDEX_2_DAY": "FEDEX_2_DAY",

  /**
   * value: "FEDEX_2_DAY_AM"
   * @const
   */
  "FEDEX_2_DAY_AM": "FEDEX_2_DAY_AM",

  /**
   * value: "FEDEX_2_DAY_FREIGHT"
   * @const
   */
  "FEDEX_2_DAY_FREIGHT": "FEDEX_2_DAY_FREIGHT",

  /**
   * value: "FEDEX_3_DAY_FREIGHT"
   * @const
   */
  "FEDEX_3_DAY_FREIGHT": "FEDEX_3_DAY_FREIGHT",

  /**
   * value: "FEDEX_EXPRESS_SAVER"
   * @const
   */
  "FEDEX_EXPRESS_SAVER": "FEDEX_EXPRESS_SAVER",

  /**
   * value: "FEDEX_FIRST_FREIGHT"
   * @const
   */
  "FEDEX_FIRST_FREIGHT": "FEDEX_FIRST_FREIGHT",

  /**
   * value: "FEDEX_FREIGHT_ECONOMY"
   * @const
   */
  "FEDEX_FREIGHT_ECONOMY": "FEDEX_FREIGHT_ECONOMY",

  /**
   * value: "FEDEX_FREIGHT_PRIORITY"
   * @const
   */
  "FEDEX_FREIGHT_PRIORITY": "FEDEX_FREIGHT_PRIORITY",

  /**
   * value: "FEDEX_GROUND"
   * @const
   */
  "FEDEX_GROUND": "FEDEX_GROUND",

  /**
   * value: "FIRST_OVERNIGHT"
   * @const
   */
  "FIRST_OVERNIGHT": "FIRST_OVERNIGHT",

  /**
   * value: "GROUND_HOME_DELIVERY"
   * @const
   */
  "GROUND_HOME_DELIVERY": "GROUND_HOME_DELIVERY",

  /**
   * value: "INTERNATIONAL_ECONOMY"
   * @const
   */
  "INTERNATIONAL_ECONOMY": "INTERNATIONAL_ECONOMY",

  /**
   * value: "INTERNATIONAL_ECONOMY_FREIGHT"
   * @const
   */
  "INTERNATIONAL_ECONOMY_FREIGHT": "INTERNATIONAL_ECONOMY_FREIGHT",

  /**
   * value: "INTERNATIONAL_FIRST"
   * @const
   */
  "INTERNATIONAL_FIRST": "INTERNATIONAL_FIRST",

  /**
   * value: "INTERNATIONAL_PRIORITY"
   * @const
   */
  "INTERNATIONAL_PRIORITY": "INTERNATIONAL_PRIORITY",

  /**
   * value: "INTERNATIONAL_PRIORITY_EXPRESS"
   * @const
   */
  "INTERNATIONAL_PRIORITY_EXPRESS": "INTERNATIONAL_PRIORITY_EXPRESS",

  /**
   * value: "INTERNATIONAL_PRIORITY_FREIGHT"
   * @const
   */
  "INTERNATIONAL_PRIORITY_FREIGHT": "INTERNATIONAL_PRIORITY_FREIGHT",

  /**
   * value: "PRIORITY_OVERNIGHT"
   * @const
   */
  "PRIORITY_OVERNIGHT": "PRIORITY_OVERNIGHT",

  /**
   * value: "SMART_POST"
   * @const
   */
  "SMART_POST": "SMART_POST",

  /**
   * value: "STANDARD_OVERNIGHT"
   * @const
   */
  "STANDARD_OVERNIGHT": "STANDARD_OVERNIGHT",

  /**
   * value: "EUROPE_FIRST_INTERNATIONAL_PRIORITY"
   * @const
   */
  "EUROPE_FIRST_INTERNATIONAL_PRIORITY": "EUROPE_FIRST_INTERNATIONAL_PRIORITY",

  /**
   * value: "FEDEX_DISTANCE_DEFERRED"
   * @const
   */
  "FEDEX_DISTANCE_DEFERRED": "FEDEX_DISTANCE_DEFERRED",

  /**
   * value: "FEDEX_NEXT_DAY_AFTERNOON"
   * @const
   */
  "FEDEX_NEXT_DAY_AFTERNOON": "FEDEX_NEXT_DAY_AFTERNOON",

  /**
   * value: "FEDEX_NEXT_DAY_EARLY_MORNING"
   * @const
   */
  "FEDEX_NEXT_DAY_EARLY_MORNING": "FEDEX_NEXT_DAY_EARLY_MORNING",

  /**
   * value: "FEDEX_NEXT_DAY_END_OF_DAY"
   * @const
   */
  "FEDEX_NEXT_DAY_END_OF_DAY": "FEDEX_NEXT_DAY_END_OF_DAY",

  /**
   * value: "FEDEX_NEXT_DAY_FREIGHT"
   * @const
   */
  "FEDEX_NEXT_DAY_FREIGHT": "FEDEX_NEXT_DAY_FREIGHT",

  /**
   * value: "FEDEX_NEXT_DAY_MID_MORNING"
   * @const
   */
  "FEDEX_NEXT_DAY_MID_MORNING": "FEDEX_NEXT_DAY_MID_MORNING",

  /**
   * value: "SAME_DAY"
   * @const
   */
  "SAME_DAY": "SAME_DAY",

  /**
   * value: "SAME_DAY_CITY"
   * @const
   */
  "SAME_DAY_CITY": "SAME_DAY_CITY"
};
/**
 * Allowed values for the <code>smart_post_indicia_type</code> property.
 * @enum {String}
 * @readonly
 */

FedexShipmentOptions['SmartPostIndiciaTypeEnum'] = {
  /**
   * value: "MEDIA_MAIL"
   * @const
   */
  "MEDIA_MAIL": "MEDIA_MAIL",

  /**
   * value: "PARCEL_SELECT"
   * @const
   */
  "PARCEL_SELECT": "PARCEL_SELECT",

  /**
   * value: "PRESORTED_BOUND_PRINTED_MATTER"
   * @const
   */
  "PRESORTED_BOUND_PRINTED_MATTER": "PRESORTED_BOUND_PRINTED_MATTER",

  /**
   * value: "PRESORTED_STANDARD"
   * @const
   */
  "PRESORTED_STANDARD": "PRESORTED_STANDARD",

  /**
   * value: "PARCEL_RETURN"
   * @const
   */
  "PARCEL_RETURN": "PARCEL_RETURN"
};
var _default = FedexShipmentOptions;
exports["default"] = _default;